module.exports = __webpack_public_path__ + "static/phone-refund-bd332143ffe57fef8b4ca4f200ecc51d.png";